var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_518",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_518)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.25 8.99998C13.6977 8.99998 13.25 8.55226 13.25 7.99998V4.5C13.25 3.94772 13.6977 3.5 14.25 3.5H19.5C20.0522 3.5 20.5 3.94772 20.5 4.5V7.99997C20.5 8.55226 20.0522 8.99998 19.5 8.99998H14.25ZM4.5 12.5C3.94771 12.5 3.5 12.0522 3.5 11.5V4.5C3.5 3.94772 3.94772 3.5 4.5 3.5H9.74995C10.3022 3.5 10.75 3.94772 10.75 4.5V11.4999C10.75 12.0522 10.3022 12.5 9.74995 12.5H4.5ZM14.25 20.5C13.6977 20.5 13.25 20.0522 13.25 19.5V12.5C13.25 11.9477 13.6977 11.5 14.25 11.5H19.5C20.0522 11.5 20.5 11.9477 20.5 12.5V19.5C20.5 20.0522 20.0522 20.5 19.5 20.5H14.25ZM4.5 20.5C3.94771 20.5 3.5 20.0522 3.5 19.5V16C3.5 15.4477 3.94772 15 4.5 15H9.74995C10.3022 15 10.75 15.4477 10.75 16V19.5C10.75 20.0522 10.3022 20.5 9.74995 20.5H4.5ZM4.99997 11H9.25V4.99998H4.99997V11ZM14.75 19H19V13H14.75V19ZM14.75 7.5H19V4.99998H14.75V7.5ZM4.99997 19H9.25V16.5H4.99997V19Z",
    fill: "#989FB5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboard);
export default __webpack_public_path__ + "static/media/icon_dashboard.85774afa36cd36f248823fa8d5f1e083.svg";
export { ForwardRef as ReactComponent };